export const navigateChapter = (setColumns, direction, columnId, handleMainSearch, books) => {
  setColumns((prevColumns) => {
    return prevColumns.map((col, idx) => {
      if (idx === columnId) {
        const currentBookIndex = books.findIndex((book) => book.name === col.book);
        if (currentBookIndex === -1) {
          console.error(`Book "${col.book}" not found in the books array.`);
          return col;
        }

        let newBook = col.book;
        let newChapter = col.chapter;

        if (direction === "next") {
          // Handle navigation to the next chapter or book
          if (newChapter < books[currentBookIndex].chapters) {
            newChapter++;
          } else if (currentBookIndex < books.length - 1) {
            newBook = books[currentBookIndex + 1].name;
            newChapter = 1;
          }
        } else if (direction === "previous") {
          // Handle navigation to the previous chapter or book
          if (newChapter > 1) {
            newChapter--;
          } else if (currentBookIndex > 0) {
            newBook = books[currentBookIndex - 1].name;
            newChapter = books[currentBookIndex - 1].chapters;
          }
        }

        handleMainSearch(col.version, columnId, newBook, newChapter);

        return { ...col, book: newBook, chapter: newChapter };
      }
      return col;
    });
  });
};
